/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByUserFeedbackV2Kind = (typeof GroupByUserFeedbackV2Kind)[keyof typeof GroupByUserFeedbackV2Kind];

export const GroupByUserFeedbackV2Kind = {
  user_feedback_v2: 'user_feedback_v2',
} as const;
